export class TrimRequest{
    structure:boolean;
    category:boolean;
    content:boolean;
    type:boolean;
    finish:boolean;
    hole:boolean;
    quality:boolean;
    thickness:boolean;
    variety:boolean;
    uom:boolean;
    color:boolean;
    logo:boolean;
    part:boolean;
    ply:boolean;
    shape:boolean;
    slider:boolean;
    length:boolean;
    line:boolean;
    buyer:boolean;
    parts:boolean;
    size:boolean;
    trimfunction:boolean;
    gauge:boolean;
    perforation:boolean;
    airhole:boolean;
    article:boolean;
    vendor:boolean;
    functions:boolean;
    innerdia:boolean
    trimMaster?: string
constructor(  
    structure:boolean,
    category:boolean,
    content:boolean,
    type:boolean,
    finish:boolean,
    hole:boolean,
    quality:boolean,
    thickness:boolean,
    variety:boolean,
    uom:boolean,
    color:boolean,
    logo:boolean,
    part:boolean,
    ply:boolean,
    shape:boolean,
    slider:boolean,
    length:boolean,
    line:boolean,
    buyer:boolean,
    parts:boolean,
    size:boolean,
    trimfunction:boolean,
    gauge:boolean,
    perforation:boolean,
    airhole:boolean,
    article:boolean,
    vendor:boolean,
    functions:boolean,
    innerdia:boolean,
    trimMaster?: string    
    ){
 this.structure=structure,
 this.category=category,
 this.content=content,
 this.type=type,
 this.finish=finish,
 this.hole=hole,
 this.quality=quality,
 this.thickness=thickness,
 this.variety=variety,
 this.uom=uom,
 this.color=color,
 this.logo=logo,
 this.part=part,
 this.ply=ply,
 this.shape=shape,
 this.slider=slider,
 this.length=length,
 this.line=line,
 this.buyer=buyer,
 this.parts=parts,
 this.size=size,
 this.trimfunction=trimfunction,
 this.gauge=gauge,
 this.perforation=perforation,
 this.airhole=airhole,
 this.article=article,
 this.vendor=vendor,
 this.functions=functions,
 this.innerdia=innerdia
 this.trimMaster = trimMaster
}
}